import React from 'react';
import OrderSummaryRow from './OrderSummaryRow';

export default class ChargesLoading extends React.Component {

    render() {
        return (
            <pui-stack>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <OrderSummaryRow loading={true}/>
                        <OrderSummaryRow loading={true}/>
                        <OrderSummaryRow loading={true}/>
                        <OrderSummaryRow loading={true}/>
                        <OrderSummaryRow loading={true}/>
                    </tbody>
                </table>
            </pui-stack>
        )
    }
}
